import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import { useEffect, useRef } from "react";
import { useAppSelector } from "store/hooks";

type LabelFieldProps = {
  name: string;
  value: string;
  onChange: (value: any) => void;
  isNewestField?: boolean;
};

const LabelField = (props: LabelFieldProps) => {
  const { isNewestField } = props;
  const inputRef = useRef<HTMLElement | null>(null);

  const selectedRoute = useAppSelector(
    (state) => state.developer.edit.editor.selectedRoute
  );

  useEffect(() => {
    if (selectedRoute && !isNewestField) {
      inputRef.current && inputRef.current.focus();
    }
  }, [selectedRoute, isNewestField]);

  return (
    <EditorVisualTextField
      label="Label"
      size="small"
      fullWidth
      inputRef={inputRef}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    />
  );
};

export default LabelField;
